document.addEventListener('DOMContentLoaded', function () {
  const collectionsContainer = document.getElementById('collections');
  const collections = Array.from(collectionsContainer.getElementsByTagName('a'));
  const setsByDateBtn = document.getElementById('sort-release-year');
  const setsByLetterBtn = document.getElementById('sort-alphabetical');

  const tabActiveClasses = '!text-black bg-white';
  const groupContainerClasses = 'break-inside-avoid-column';
  const navigationLinksClasses =
    'border-b border-white my-6 bg-white w-full flex gap-px sticky top-0 z-[1] justify-stretch';
  const navLinkClasses =
    'w-full bg-gray-100 text-black py-3 inline-block text-sm text-center hover:underline sm:text-base';
  const headerClasses = 'border-b border-black font-bold pt-4 pb-2 text-xl';
  const collectionWrapperClasses = 'bg-gray-200';

  const dateGroupClasses = 'Timeline mt-6';
  const letterGroupClasses = 'mt-6 sm:columns-2 lg:columns-3';

  let allCollections = [...collections];

  const sortByDateDesc = (a, b) =>
    new Date(b.getAttribute('data-release-date')) - new Date(a.getAttribute('data-release-date'));
  const sortByLetter = (a, b) =>
    a.getAttribute('data-set-name').localeCompare(b.getAttribute('data-set-name'), undefined, { sensitivity: 'base' });

  allCollections.sort(sortByDateDesc);

  function createNavigationLinks(links, classes) {
    const navigationLinks = document.createElement('div');
    navigationLinks.id = 'navigation-links';
    navigationLinks.className = navigationLinksClasses;

    if (classes) {
      navigationLinks.classList.add(...classes.split(' '));
    }

    links.forEach((link) => {
      const anchor = document.createElement('a');
      anchor.href = link.href;
      anchor.textContent = link.text;
      anchor.className = navLinkClasses;
      navigationLinks.appendChild(anchor);
    });

    if (!document.getElementById('navigation-links')) {
      collectionsContainer.parentNode.insertBefore(navigationLinks, collectionsContainer);
    }
  }

  function removeNavigationLinks() {
    const navigationLinks = document.getElementById('navigation-links');
    if (navigationLinks) navigationLinks.remove();
  }

  function appendGroup(group, title, id) {
    const groupContainer = document.createElement('div');
    groupContainer.className = groupContainerClasses;

    const header = document.createElement('h2');
    header.textContent = title;
    header.id = id;
    header.className = headerClasses;
    groupContainer.appendChild(header);

    const collectionWrapper = document.createElement('div');
    collectionWrapper.className = collectionWrapperClasses;

    group.forEach((collection) => collectionWrapper.appendChild(collection));
    groupContainer.appendChild(collectionWrapper);
    collectionsContainer.appendChild(groupContainer);
  }

  function renderGroups(groups, className) {
    collectionsContainer.innerHTML = '';
    collectionsContainer.className = className;

    groups.forEach(({ group, title, id }) => appendGroup(group, title, id));

    collectionsContainer.classList.remove('hidden');
    const loadingDiv = document.getElementById('loading');
    if (loadingDiv) loadingDiv.remove();
  }

  function renderLetterGroups() {
    const hashMap = { '#': [] };
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach((letter) => {
      hashMap[letter] = [];
    });

    allCollections.forEach((collection) => {
      const setName = collection.getAttribute('data-set-name');
      const firstLetter = setName ? setName.charAt(0).toUpperCase() : '#';
      const isAlphabetic = /^[A-Z]$/.test(firstLetter);
      const key = isAlphabetic ? firstLetter : '#';

      hashMap[key].push(collection);
    });

    const groups = Object.keys(hashMap).map((letter) => ({
      group: hashMap[letter],
      title: letter,
      id: `letter-${letter}`,
    }));

    renderGroups(groups, letterGroupClasses);
  }

  function renderYearGroups() {
    const yearHashMap = {};

    allCollections.forEach((collection) => {
      const releaseDate = new Date(collection.getAttribute('data-release-date'));
      const year = releaseDate.getFullYear();

      if (!yearHashMap[year]) {
        yearHashMap[year] = [];
      }

      yearHashMap[year].push(collection);
    });

    const groups = Object.keys(yearHashMap)
      .sort((a, b) => b - a) // Sort years in descending order
      .map((year) => ({
        group: yearHashMap[year],
        title: year,
        id: `year-${year}`,
      }));

    renderGroups(groups, dateGroupClasses);
    adjustTimelineLayout();
  }

  function adjustTimelineLayout() {
    let vw = window.innerWidth;
    let spaceToTake = 0;
    document.querySelectorAll('.break-inside-avoid-column').forEach((groupContainer, idx) => {
      groupContainer.classList.add(...['relative', 'w-1/2']);

      const currentHeight = groupContainer.offsetHeight;

      if (vw > 750) {
        if (idx % 2 === 0) {
          groupContainer.classList.add('pr-6');
        }
        if (idx % 2 === 1) {
          groupContainer.classList.add('pl-6');
          groupContainer.classList.add('left-1/2');
        }

        if (idx == 1) {
          const marginTop = document.querySelectorAll('.break-inside-avoid-column')[0].offsetHeight * 0.8;
          groupContainer.style.marginTop = `-${marginTop}px`;
          spaceToTake = currentHeight - marginTop;
        } else {
          if (spaceToTake > currentHeight) {
            spaceToTake = currentHeight - 50;
          }
          groupContainer.style.marginTop = `-${spaceToTake}px`;
          spaceToTake = currentHeight - spaceToTake;
        }
      } else {
        groupContainer.classList.remove('pr-6');
        groupContainer.classList.remove('pl-6');
        groupContainer.classList.remove('left-1/2');
        groupContainer.classList.remove('w-1/2');
        groupContainer.style.marginTop = '0px';

        groupContainer.classList.add('pl-6');
      }
    });
  }

  function addIntersectionObserver() {
    const sections = document.querySelectorAll('h2[id^="year-"]');
    const navLinks = document.querySelectorAll('#navigation-links a');

    const options = {
      root: null,
      rootMargin: '0px 0px -25% 0px',
      threshold: 0.25,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          navLinks.forEach((link) => {
            link.classList.toggle('NavLink--active', link.getAttribute('href') === `#${entry.target.id}`);
          });
        }
      });
    }, options);

    sections.forEach((section) => observer.observe(section));
  }

  function handleSortByDate() {
    setsByLetterBtn.classList.remove(...tabActiveClasses.split(' '));
    setsByDateBtn.classList.add(...tabActiveClasses.split(' '));
    removeNavigationLinks();

    allCollections.sort(sortByDateDesc);
    renderYearGroups();
    addIntersectionObserver();
    window.addEventListener('resize', adjustTimelineLayout);
  }

  function handleSortByLetter() {
    setsByDateBtn.classList.remove(...tabActiveClasses.split(' '));
    setsByLetterBtn.classList.add(...tabActiveClasses.split(' '));
    removeNavigationLinks();

    allCollections.sort(sortByLetter);
    renderLetterGroups();
    window.removeEventListener('resize', adjustTimelineLayout);
  }

  setsByDateBtn.addEventListener('click', handleSortByDate);
  setsByLetterBtn.addEventListener('click', handleSortByLetter);
  handleSortByDate();
});
